import { gql } from "@apollo/client";

export const GET_TOKEN = gql`
  query GetToken($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      response
      refresh
      expireHours
      userInfo {
        salesPersonId
        salesPersonGuid
        salesPersonName
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles
        tenantId
        rolesGuids
      }
    }
  }
`;

export const SIGN_UP_INVITATION = gql`
  query SignUpInvitation($email: String!, $subscriptionKey: String!) {
    signUpInvitation(
      model: {
        email: $email
        subscriptionKey: $subscriptionKey
      }
    ) {
      status
      exceptionMessage
    }
  }
`;

export const GET_STATEMENTS = gql`
  query GetStatements($activityId: Int) {
    activityStatements(where: { activityId: { eq: $activityId } }) {
      edges {
        node {
          statementCode
          statementText
          value
          guid
        }
      }
    }
  }
`;

export const GET_GUID = gql`
  query GetGuid($activityId: Int) {
    activities(where: { activityId: { eq: $activityId } } ) {
      edges {
        node {
          guid
        }
      }
    }
  }
`;

export const GET_ACTIVITIES = gql`
  query GetActivities(
    $cursor: String
    $salesPersonGuid: UUID
    $activityTypeGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        createSalesPerson: { guid: { eq: $salesPersonGuid } }
        activityType: { guid: { eq: $activityTypeGuid } }
      }
      
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          createSalesPerson {
            name
          }
          guid
          updateVersion
          activityId
          projectId
          childActivities {
            updateVersion
            activityStatusReason {
              displayName
            }
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText
              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          planDateTime
          planEndDateTime
          activityStatusId
          customer {
            displayName
            guid
            customerCategoryId
            customerTypeId
            customerReference
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid
              activityStatementId
              document {
                guid
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;

export const GET_SELECTED_ACTIVITY = gql`
query GetActivities($activityGuid: UUID) {
  activities(where: { guid: { eq: $activityGuid } }) {
    edges {
      node {
        activityId
        guid
        updateVersion
        projectId
        planDateTime
        activityStatus {
          activityStatusId
          guid
          displayName
          activityStatusWorkflowToActivityStatusesWf {
            activityStatusWorkflowId
            toActivityStatusId
            isDefault
            role
          }
        }
        activityType {
          guid
          workflow {
            workflowId
            activityStatusWorkflows {
              toActivityStatusId
              role
            }
          }
        }
        activityStatusId
        activityStatus {
          guid
        }
        activityDocuments {
          guid
          document {
            fileName
            guid
            originalFileName
            documentTypeCode
          }
          activityStatement {
            statementCode
          }
        }
        activityStatements {
          guid
          titleText
          value
          dataType
          statementText
          statementCode
          notes
        }
        childActivities {
          updateVersion
          planDateTime
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }
            activityStatement {
              statementCode
            }
          }
          activityId
          activityStatusId
          guid
          activityStatements {
            titleText
            guid

            jsonValues {
              items {
                option
              }
            }
            statementCode
            value
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
        }
      }
    }
  }
}
`;

export const GET_CURRENT_ACTIVITIES_FOR_CHILD = gql`
  query GetActivities($activityGuid: UUID) {
    activities(where: { guid: { eq: $activityGuid } } ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          updateVersion
          childActivities {
            guid
            updateVersion
          }
        }
      }
    }
  }
`;

export const GET_ACTIVITIES_FOR_DASHBOARD = gql`
query GetActivitiesForDashboard(
  $value: String
  $cursor: String
  $first: Int = 50
) {
  activityStatements(
    where: {
      activityTypeStatement: {
        guid: {
          in: [
            "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
            "90F89BF5-F284-492E-8E26-0FEF45355112"
            "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
            "CAEDDF12-EE59-4858-8F0B-37B56655A903"
            "2D3FFB7E-2340-4167-AB78-93A72C31B0DF"
          ]
        }
      }
      activity: {
        activityStatus: {
          guid: {
            nin: [
              "B2EDE7E1-424E-449C-98F6-3063E2F57B03"
              "7EC46344-0904-4F0A-B22D-52A5E1B6D86D"
            ]
          }
        }
      }
      value: { contains: $value }
    }
    first: $first
    after: $cursor
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        statementCode
        value
        activity {
          activityId
          guid
          createSalesPerson {
            name
            guid
          }
          activityStatements {
            statementCode
            statementText
            value
          }
          activityStatus {
            displayName
          }
          childActivities {
            activityId
            guid
            updateVersion
            planDateTime
            activityStatus {
              displayName
            }
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                }
              }
            }
            activityStatements {
              statementCode
              value
            }
          }
          activityType {
            guid
          }
        }
      }
    }
  }
}
`;

export const GET_ACTIVITY_COUNT = (role) => gql`
  query GetActivityCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
              "CAEDDF12-EE59-4858-8F0B-37B56655A903"
              "2D3FFB7E-2340-4167-AB78-93A72C31B0DF"
            ]
          }
        }
        activity: {
          childActivities: {
            some: {
              activityStatus: {
                guid: {
                  in: [
                    "81030362-cba4-4f59-a393-266da421e990"
                    "b8d42ec3-8782-46fb-9aeb-a09d0589009e"
                    "cba96afa-efac-4e52-9281-802a520bc0b9"
                    ${role.includes("Gözlemci") || role.includes("Öğrenci") ? "1e7e560c-7f09-427e-bfcd-76c870f3cac7" : ""}
                    ${role.includes("Gözlemci") || role.includes("Öğrenci") ? "d6539adb-179a-4a91-86d1-6bf552c7be23" : ""}
                    ${role.includes("Gözlemci") || role.includes("Öğrenci") ? "2bcc90c1-6ac9-4a6a-9a9d-422073dc3abc" : ""}
                  ]
                }
              }
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Self Report Preview Count
export const GET_SELF_REPORT_PREVIEW_COUNT = (role) => gql`
  query GetSelfReportPreviewCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              ${role.includes("TB") ? '"0AADE690-46F2-4F70-8953-9B2F09D7B3CD"' : ""}
              ${role.includes("Değerlendirici") ? '"90F89BF5-F284-492E-8E26-0FEF45355112"' : ""}
              ${role.includes("Değerlendirici") ? '"1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"' : ""}
              ${role.includes("Gözlemci") ? '"CAEDDF12-EE59-4858-8F0B-37B56655A903"' : ""}
              ${role.includes("Öğrenci") ? '"2D3FFB7E-2340-4167-AB78-93A72C31B0DF"' : ""}
            ]
          }
        }
        activity: {
          childActivities: {
            some: {
              activityStatus: {
                guid: {
                  in: [
                    "81030362-cba4-4f59-a393-266da421e990"
                    ${role.includes("Gözlemci") || role.includes("Öğrenci") ? "" : '"b8d42ec3-8782-46fb-9aeb-a09d0589009e"'}
                    ${role.includes("Gözlemci") || role.includes("Öğrenci") ? "" : '"cba96afa-efac-4e52-9281-802a520bc0b9"'}
                  ]
                }
              }
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Formal Review Count  
export const GET_FORMAL_REVIEW_COUNT = (role) => gql`
  query GetFormalReviewCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
            ]
          }
        }
        activity: {
          childActivities: {
            some: {
              activityStatus: {
                guid: { eq: "1e865697-ab50-4a1d-87eb-607545d84a21" }
              }
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Evaluation Count
export const GET_EVALUATION_COUNT = (role) => gql`
  query GetEvaluationCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
            ]
          }
        }
        activity: {
          childActivities: {
            some: {
              activityStatus: {
                guid: { in: [
                  "b8d42ec3-8782-46fb-9aeb-a09d0589009e"
                  "1e865697-ab50-4a1d-87eb-607545d84a21"
                  "d6539adb-179a-4a91-86d1-6bf552c7be23"
                ] }
              }
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Evaluator Reports Count
export const GET_EVALUATOR_REPORTS_COUNT = (role) => gql`
  query GetEvaluatorReportsCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
              "CAEDDF12-EE59-4858-8F0B-37B56655A903"
              "2D3FFB7E-2340-4167-AB78-93A72C31B0DF"
            ]
          }
        }
        activity: {
          childActivities: {
            some: {
              activityStatus: {
                guid: {
                  in: [
                    "A8B7C6D5-E4F3-4142-9876-543210ABCDEF"
                    "B9C8D7E6-F5A4-4253-A987-654321BCDEFG"
                  ]
                }
              }
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Draft Report Count
export const GET_DRAFT_REPORT_COUNT = (role) => gql`
  query GetDraftReportCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
            ]
          }
        }
        activity: {
          activityStatus: {
            guid: {
              in: [
                "3F45C1CC-CB37-4D7C-AF74-ECDB52C114C7"
                "9053B89D-E43C-4ABD-82AC-C72D9FC0BC2D"
              ]
            }
          }
          childActivities: {
            some: {
              activityStatus: {
                guid: { eq: "1E7E560C-7F09-427E-BFCD-76C870F3CAC7" }
              }
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Consistency Final Report Count 
export const GET_CONSISTENCY_FINAL_REPORT_COUNT = (role) => gql`
  query GetConsistencyFinalReportCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
            ]
          }
        }
        activity: {
          activityStatus: {
            guid: { eq: "3F45C1CC-CB37-4D7C-AF74-ECDB52C114C7" }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount  
    }
  }
`;

// Final Report Count
export const GET_FINAL_REPORT_COUNT = (role) => gql`
  query GetFinalReportCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
              "CAEDDF12-EE59-4858-8F0B-37B56655A903"
              "2D3FFB7E-2340-4167-AB78-93A72C31B0DF"
            ]
          }
        }
        activity: {
          activityStatus: {
            guid: { eq: "FB0B49EC-53DE-4BDA-AE0E-500CAEDE5F64" }
          }
          childActivities: {
            some: {
              activityStatus: {
                guid: { eq: "D6539ADB-179A-4A91-86D1-6BF552C7BE23" }
              }
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Applications Count
export const GET_APPLICATIONS_COUNT = (role) => gql`
  query GetApplicationsCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
              "CAEDDF12-EE59-4858-8F0B-37B56655A903"
              "2D3FFB7E-2340-4167-AB78-93A72C31B0DF"
            ]
          }
        }
        activity: {
          activityStatus: {
            guid: {
              in: [
                "F1E2D3C4-B5A6-4789-CDEF-123456789ABC"
                "A9B8C7D6-E5F4-4321-9876-FEDCBA987654"
              ]
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Self Report Count
export const GET_SELF_REPORT_COUNT = (role) => gql`
  query GetSelfReportCount($value: Int) {
    activities(
      where: {
        activityType: { guid: { eq: "39451573-4A59-44CA-AB7E-264BA03078E9" } }
        activityStatus: { guid: { eq: "15E7D9B9-1BD6-424B-BF7D-77ECBB0979D1" } }
        createSalesPerson: { salesPersonId: { eq: $value } }
      }
    ) {
      totalCount
    }
  }
`;

// Month Response Count  
export const GET_MONTH_RESPONSE_COUNT = (role) => gql`
  query GetMonthResponseCount($value: Int) {
    activities(
      where: {
        childActivities: {
          some: {
            createSalesPerson: { salesPersonId: { eq: $value } }
            activityType: { guid: { eq: "39451573-4A59-44CA-AB7E-264BA03078E9" } }
            activityStatus: {
              guid: { eq: "1e7e560c-7f09-427e-bfcd-76c870f3cac7" }
            }
          }
        }
      }
    ) {
      totalCount
    }
}
`;

// Application Loop Count
export const GET_APPLICATION_LOOP_COUNT = (role) => gql`
  query GetApplicationLoopCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
              "CAEDDF12-EE59-4858-8F0B-37B56655A903"
              "2D3FFB7E-2340-4167-AB78-93A72C31B0DF"
            ]
          }
        }
        activity: {
          activityStatus: {
            guid: {
              in: [
                "55555555-5555-5555-5555-555555555555"
                "66666666-6666-6666-6666-666666666666"
              ]
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

// Consistency Reports Count
export const GET_CONSISTENCY_COUNT = (role) => gql`
  query GetConsistencyCount {
    activities(
      where: {
        activityType: { guid: { eq: "07EF8AFD-4944-4DB0-9773-E9A0A0CBD9CB" } }
        activityStatus: { guid: { eq: "ddc5fb48-cbf8-4d4a-a8f4-f649e23cbd4d" } }
      }
    ) {
      totalCount
    }
  }
`;

// Editor Reports Count
export const GET_EDITOR_COUNT = (role) => gql`
  query GetEditorCount {
    activities(
      where: {
        activityType: { guid: { eq: "07EF8AFD-4944-4DB0-9773-E9A0A0CBD9CB" } }
        activityStatus: { guid: { eq: "af65b2ab-1a73-4889-b358-3cb287fd726d" } }
      }
    ) {
      totalCount
    }
  }
`;

// Spelling Control Count
export const GET_SPELLING_CONTROL_COUNT = (role) => gql`
  query GetSpellingControlCount($value: String) {
    activityStatements(
      where: {
        activityTypeStatement: {
          guid: {
            in: [
              "0AADE690-46F2-4F70-8953-9B2F09D7B3CD"
              "90F89BF5-F284-492E-8E26-0FEF45355112"
              "1F6A4C44-4F41-415E-8841-EF48D7F2C0F7"
              "CAEDDF12-EE59-4858-8F0B-37B56655A903"
              "2D3FFB7E-2340-4167-AB78-93A72C31B0DF"
            ]
          }
        }
        activity: {
          activityStatus: {
            guid: {
              in: [
                "BBBBBBBB-BBBB-BBBB-BBBB-BBBBBBBBBBBB"
                "CCCCCCCC-CCCC-CCCC-CCCC-CCCCCCCCCCCC"
              ]
            }
          }
        }
        value: { contains: $value }
      }
    ) {
      totalCount
    }
  }
`;

export const GET_ACTIVITIES_FOR_PARENT_CHILD = gql`
  query GetActivities($cursor: String, $activityTypeGuid: UUID) {
    activities(
      after: $cursor
      order: { activityId: ASC }
      where: { activityType: { guid: { eq: $activityTypeGuid } } }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }
          planDateTime
          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText
              guid
              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
            activityTypeStatements {
              statementCode
              informationText
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;
/* export const GET_ACTIVITIES_FOR_PARENT_CHILD = gql`
  query GetActivities(
    $cursor: String
    $salesPersonGuid: UUID
    $activityTypeGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        salesPerson: { guid: { eq: $salesPersonGuid } }
        activityType: { guid: { eq: $activityTypeGuid } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }
          planDateTime
          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`; */

export const GET_ACTIVITIES_WITH_STATUSID = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        activityStatus: { guid: { eq: $activityStatusGuid } }
        activityType: { guid: { eq: $activityTypeGuid } }
      }
      
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          planDateTime
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }

          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            activityTypeStatements {
              statementCode
              informationText
            }
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;

export const GET_MULTIPLE_ACTIVITIES_FOR_DRAFT = gql`
  query {
    activities(
      where: {
        activityStatus: {
          guid: {
            in: [
              "3F45C1CC-CB37-4D7C-AF74-ECDB52C114C7"
              "9053B89D-E43C-4ABD-82AC-C72D9FC0BC2D"
            ]
          }
        }
        activityType: { guid: { eq: "07EF8AFD-4944-4DB0-9773-E9A0A0CBD9CB" } }
      }
      
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          planDateTime
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }

          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;

export const GET_ACTIVITIES_WITH_UPDATE_VERSION_USING_GUIDS = gql`
  query GetActivities($activityGuid: UUID) {
    activities(where: { guid: { eq: $activityGuid } } ) {
      edges {
        node {
          guid

          updateVersion
          childActivities {
            activityId
            guid
            updateVersion
          }
          activityId
        }
      }
    }
  }
`;

export const GET_CHILD_PARENT_ACTIVITY_DOCUMENTS = gql`
  query GetActivities($activityGuid: UUID) {
    activities(where: { guid: { eq: $activityGuid } } ) {
      edges {
        node {
          guid
          activityDocuments {
            guid
            documentId
            activityStatement {
              statementCode
            }
            document {
              guid
              fileName
              originalFileName
              documentTypeCode
            }
          }
          activityId
          childActivities {
            activityId
            activityStatements {
              statementCode
              value
            }
            guid
            updateVersion
            activityDocuments {
              guid
              documentId
              activityStatement {
                statementCode
              }
              document {
                guid
                fileName
                originalFileName
                documentTypeCode
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_SALESPERSON_ID = gql`
  query ($guid: UUID!) {
    salesPeople(where: { guid: { eq: $guid } }) {
      edges {
        node {
          worksInCustomerId
        }
      }
    }
  }
`;

export const GET_UNIVERSITY_FACULTY = gql`
  query ($worksInCustomerID: Int) {
    customers(where: { customerId: { eq: $worksInCustomerID } }) {
      edges {
        node {
          displayName
          brandName
          addressCity
          addressLine1
        }
      }
    }
  }
`;

export const GET_EMPTY_ACTIVITY = gql`
  query ($paramGuid: UUID!) {
    createEmptyActivity(activityTypeGuid: $paramGuid) {
      activityTypeGuid
      notes
      planDateTime
      planEndDateTime
      activityStatements {
        titleText
        statementCode
        statementText
        dataType
        notes

        jsonValues {
          items {
            option
          }
        }
      }
      avaibleEmptyActivityStatusModelList {
        displayName
        guid
        colorCode
        isCancelled
        isPlanned
        isInProgress
        isCompleted
        isClosed
      }
    }
  }
`;

export const GET_NESTED_ACTIVITY = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusGuid: UUID
    $salesPersonGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        activityType: { guid: { eq: $activityTypeGuid } }
        activityStatus: { guid: { eq: $activityStatusGuid } }
        createSalesPerson: { guid: { eq: $salesPersonGuid } }
      }
      
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          guid
          updateVersion
          parentActivity {
            planDateTime
            activityId
            activityType {
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
              guid
            }
            guid
            updateVersion
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
            activityStatements {
              statementCode
              value
              titleText
            }
            createSalesPerson {
              name
            }
            childActivities {
              activityId
              planDateTime
              activityType {
                guid
                workflow {
                  workflowId
                  activityStatusWorkflows {
                    toActivityStatusId
                    role
                  }
                }
              }
              guid
              activityStatusId
              activityStatus {
                activityStatusId
                guid
                displayName
                activityStatusWorkflowToActivityStatusesWf {
                  activityStatusWorkflowId
                  toActivityStatusId
                  isDefault
                  role
                }
              }
              activityStatements {
                statementCode
                value
                titleText
              }
              updateVersion
            }
          }
        }
      }
    }
  }
`;

export const GET_NESTED_ACTIVITY_SALESPERSON = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        activityType: { guid: { eq: $activityTypeGuid } }
        activityStatus: { guid: { eq: $activityStatusGuid } }
      }
      
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          guid
          updateVersion
          salesPerson {
            guid
          }
          parentActivity {
            planDateTime
            activityId
            activityType {
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
              activityTypeStatements {
                statementCode
                informationText
              }
              guid
            }
            guid
            updateVersion
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
            activityStatements {
              guid
              statementCode
              value
              titleText
            }
            createSalesPerson {
              name
            }
            childActivities {
              activityId
              planDateTime
              salesPerson {
                guid
              }
              activityType {
                guid
                workflow {
                  workflowId
                  activityStatusWorkflows {
                    toActivityStatusId
                    role
                  }
                }
              }
              guid
              activityStatusId
              activityStatus {
                activityStatusId
                guid
                displayName
                activityStatusWorkflowToActivityStatusesWf {
                  activityStatusWorkflowId
                  toActivityStatusId
                  isDefault
                  role
                }
              }
              activityStatements {
                guid
                statementCode
                value
                titleText
              }
              updateVersion
            }
          }
        }
      }
    }
  }
`;

export const GET_NESTED2_ACTIVITY = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusId: Int
    $activityStatusId1: Int
  ) {
    activities(
      after: $cursor
      where: {
        activityType: { guid: { eq: $activityTypeGuid } }
        or: [
          { activityStatusId: { eq: $activityStatusId } }
          { activityStatusId: { eq: $activityStatusId1 } }
        ]
      }
      
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          guid
          updateVersion
          parentActivity {
            activityId
            activityType {
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
              guid
            }
            guid
            updateVersion
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
            activityStatements {
              statementCode
              value
              titleText
            }
            createSalesPerson {
              name
            }
            childActivities {
              activityId
              activityType {
                guid
                workflow {
                  workflowId
                  activityStatusWorkflows {
                    toActivityStatusId
                    role
                  }
                }
              }
              guid
              activityStatusId
              activityStatus {
                activityStatusId
                guid
                displayName
                activityStatusWorkflowToActivityStatusesWf {
                  activityStatusWorkflowId
                  toActivityStatusId
                  isDefault
                  role
                }
              }
              activityStatements {
                statementCode
                value
                titleText
              }
              updateVersion
            }
          }
        }
      }
    }
  }
`;

export const GET_ACTIVITY_TYPE_STATEMENTS = gql`
  query GetActivityTypeStatements(
    $cursor: String
    $activityTypeId: Int
    $titleText: String
  ) {
    activityTypeStatements(
      after: $cursor
      where: {
        activityTypeId: { eq: $activityTypeId }
        titleText: { eq: $titleText }
      }
        first: 30
    ) {
      edges {
        node {
          statementText
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;


export const GET_PROJECT_ID_BY_GUID = gql`
  query GetProjectIdByGuid($guid: UUID!) {
    projects(where: { guid: { eq: $guid } }) {
      edges {
        node {
          projectId
        }
      }
    }
  }
`;


export const GET_CUSTOMER_TYPE_ID_BY_GUID = gql`
  query GetCustomerTypeIdByGuid($guid: UUID!) {
    customerTypes(where: { guid: { eq: $guid } }) {
      edges {
        node {
          customerTypeId
        }
      }
    }
  }
`;

export const GET_SALES_REGION_ID_BY_GUID = gql`
  query GetSalesRegionIdByGuid($guid: UUID!) {
    salesRegions(where: { guid: { eq: $guid } }) {
      edges {
        node {
          salesRegionId
        }
      }
    }
  }
`;

export const GET_SALES_PERSON_UPDATE_VERSION = gql`
  query GetSalesPersonUpdateVersion($guid: UUID!) {
    salesPeople(where: { guid: { eq: $guid } }) {
      edges {
        node {
          updateVersion
        }
      }
    }
  }
`;